import React from 'react';

function Parents() {
    return (
        <div className="parents-page">
            <h1>Information for Parents</h1>
            
            <section className="parents-intro">
                <p>
                    At Egna Le Egna, we understand how important it is for parents to feel confident in the programs their children participate in. Our mentorship program is designed to support your child’s academic journey by providing personalized guidance, resources, and encouragement. We aim to help Ethiopian and Eritrean students succeed in high school and beyond, preparing them for college and their future careers.
                </p>
            </section>

            <section className="parents-benefits">
                <h2>Benefits for Your Child</h2>
                <ul>
                    <li><strong>Personalized Mentorship:</strong> Your child will receive one-on-one mentorship from a college student or graduate who understands the challenges and opportunities they face.</li>
                    <li><strong>Academic Support:</strong> We offer tutoring, ACT/SAT preparation, and academic guidance to help your child excel in their studies.</li>
                    <li><strong>College Preparation:</strong> Our program provides resources and support to help your child navigate the college application process, from selecting the right schools to writing application essays.</li>
                    <li><strong>Free of Charge:</strong> All our services are provided at no cost, ensuring that your child has access to the resources they need regardless of financial circumstances.</li>
                </ul>
            </section>



            <section className="parents-faqs">
                <h2>Frequently Asked Questions (FAQs)</h2>
                <ul>
                    <li><strong>Who are the mentors?</strong> Our mentors are Ethiopian and Eritrean college students and graduates who are passionate about helping younger students succeed. They have been carefully selected and trained to provide the best support possible.</li>
                    <li><strong>How often will my child meet with their mentor?</strong> We encourage mentees to meet with their mentors at least twice a month, either via email, video call, or phone. The frequency and mode of communication can be adjusted to fit your child’s needs.</li>
                    <li><strong>Is there a cost to participate?</strong> No, our program is completely free of charge.</li>
                    <li><strong>How do I know if this program is right for my child?</strong> If your child is an Ethiopian or Eritrean high school student who could benefit from academic support, college preparation, and mentorship, this program is designed for them.</li>
                    <li><strong>How can I stay informed about my child's progress?</strong> We encourage open communication between parents, mentees, and mentors. Additionally, our program coordinator will provide regular updates and is always available to address any concerns you may have.</li>
                </ul>
            </section>

            <section className="parents-contact">
                <h2>Contact Us</h2>
                <p>
                    If you have any further questions or would like more information about the program, please feel free to contact us. You can reach out to us via email at <a href="mailto:Egnaleegnamentors@gmail.com">Egnaleegnamentors@gmail.com</a> or follow us on Instagram at <a href="https://www.instagram.com/ELE_Mentors" target="_blank" rel="noopener noreferrer">@ELE_Mentors</a>.
                </p>
            </section>
        </div>
    );
}

export default Parents;
